// 3D/Bin.js 수정
import { factoredInteger } from './util';
import { createLogger } from "../lib/log";
const log = createLogger('3D:');

export default class Bin {

  name = '';
  width = 0;
  height = 0;
  depth = 0;
  maxWeight = 0;
  items = [];

  constructor(name, w, h, d, mw) {
    this.name = name;
    this.width = factoredInteger(w);
    this.height = factoredInteger(h);
    this.depth = factoredInteger(d);
    this.maxWeight = factoredInteger(mw);
  }

  getName() { return this.name; }
  getWidth() { return this.width; }
  getHeight() { return this.height; }
  getDepth() { return this.depth; }
  getMaxWeight() { return this.maxWeight; }
  getItems() { return this.items; }

  getVolume() {
    return this.getWidth() * this.getHeight() * this.getDepth();
  }

  getPackedWeight() {
    return this.items.reduce((weight, item) => weight + item.getWeight(), 0);
  }

  weighItem(item) {
    const maxWeight = this.getMaxWeight();
    return !maxWeight || (item.getWeight() + this.getPackedWeight() <= maxWeight);
  }

  scoreRotation(item, rotationType) {
    item.rotationType = rotationType;
    let d = item.getDimension();
    if (this.getWidth() < d[0] || this.getHeight() < d[1] || this.getDepth() < d[2]) {
      return 0;
    }

    const widthScore = Math.pow(d[0] / this.getWidth(), 2);
    const heightScore = Math.pow(d[1] / this.getHeight(), 2);
    const depthScore = Math.pow(d[2] / this.getDepth(), 2);
    return widthScore + heightScore + depthScore;
  }

  getBestRotationOrder(item) {
    const rotationScores = {};
    for (let r of item.allowedRotation) {
      rotationScores[r] = this.scoreRotation(item, r);
    }
    const sorted = Object.keys(rotationScores)
      .sort((a,b)=>rotationScores[b]-rotationScores[a])
      .map(Number);
    return sorted;
  }

  /**
   * checkCollision:
   * 아이템을 (px, py, pz)에 놓았을 때 충돌하는지 검사
   */
  checkCollision(item, px, py, pz) {
    const d = item.getDimension();
    item.position = [px, py, pz];
    for (let placed of this.items) {
      if (placed.intersect(item)) return true;
    }
    // 범위 검사
    if (px+d[0]>this.getWidth() || py+d[1]>this.getHeight() || pz+d[2]>this.getDepth()) {
      return true; // 범위를 넘어서면 충돌로 간주
    }
    return false;
  }

  /**
   * findLowestPosition:
   * (px, pz) 위치에서 아이템을 놓을 때,
   * 0 ~ py 범위 내에서 아이템이 충돌 없이 놓을 수 있는 최소 py를 이진 탐색으로 찾는다.
   */
  findLowestPosition(item, px, pz, py) {
    let low=0, high=py;
    while(low<high) {
      let mid = Math.floor((low+high)/2);
      if(this.checkCollision(item, px, mid, pz)) {
        // 충돌 발생 -> 더 높게
        low = mid+1;
      } else {
        // 충돌 없음 -> 더 낮게 갈 수 있는지 확인
        high = mid;
      }
    }
    return low; // low == high
  }

  putItem(item, p) {
    const rotations = this.getBestRotationOrder(item);
    let fit=false;

    for (let r of rotations) {
      item.rotationType = r;
      const d = item.getDimension();

      // 먼저 범위 기본 검사
      if (p[0]+d[0]>this.getWidth() || p[2]+d[2]>this.getDepth()) {
        continue; // 이 회전 불가
      }

      // 우선 높은 py에서 충돌 없나 확인 (p[1]은 피벗)
      // 만약 p[1]에서 충돌이면 이 회전 안됨
      if(this.checkCollision(item, p[0], p[1], p[2])) {
        continue;
      }

      // 이 회전으로 p[1]에서 충돌 없으니
      // 더 낮출 수 있는지 이진 탐색
      const finalY = this.findLowestPosition(item, p[0], p[2], p[1]);

      // finalY에서 다시 충돌 체크 불필요 (findLowestPosition이 보장)
      // 단, finalY+d[1]이 높이를 넘는지 확인
      if (finalY + d[1] > this.getHeight()) {
        // 높이 초과면 불가능
        continue;
      }

      // 여기까지 왔으면 finalY에서 문제 없음
      item.position = [p[0], finalY, p[2]];
      this.items.push(item);
      fit=true;
      break;
    }

    log('try to putItem', fit, 'item', item.toString(), 'box', this.toString());
    return fit;
  }

  toString() {
    return `Bin:${this.name} (WxHxD = ${this.getWidth()}x${this.getHeight()}x${this.getDepth()}, MaxWg. = ${this.getMaxWeight()})`;
  }
}
